import React, { useState } from "react";
import FilterOrganizationButton from "../partials/actions/FilterOrganizationButton";
import AddEditOrganizationPopup from "../partials/dashboard/AddEditOrganizationPopup";
import OrganizationManagementTable from "../partials/dashboard/OrganizationManagementTable";
function OrganizationManagement() {
  const [showPopup, setShowPopup] = useState(false);
  const [click, setClick] = useState(false);
  const [search, setSearch] = useState("");
  const [sortedBy,setSortedBy] = useState("");
  
  

  const handleClosePopup = () => {
    setShowPopup(false);
  };
  const handleAdd = () => {
    setShowPopup(true);
  };

  return (
    <>
      {/* Dashboard actions */}
            <div className=" flex justify-end mb-8">


              {/* Right: Actions */}
              <div className="grid grid-flow-col sm:auto-cols-max justify-end sm:justify-end gap-2">
                {/* Filter button */}
                <FilterOrganizationButton 
                sortedBy={sortedBy}
                setSortedBy={setSortedBy}
                 />
                {/* Datepicker built with flatpickr */}
                {/*<Datepicker />*/}
                {/* Add view button */}
               {/* <button className="btn bg-indigo-500 hover:bg-indigo-600 text-white" onClick={() => handleAdd()}>
                  <svg
                    className="w-4 h-4 fill-current opacity-50 shrink-0"
                    viewBox="0 0 16 16"
                  >
                    <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                  </svg>
                  <span className="hidden xs:block ml-2">Add Organization</span>
  </button>*/}
              </div>
            </div>

            {/* Cards */}
            <div className="grid grid-cols-12 gap-6">
              <OrganizationManagementTable 
               search={search}
               setSearch={setSearch} 
               click={click}
               setClick={setClick}
               sortedBy={sortedBy}
               setSortedBy={setSortedBy}
               />
            </div>
      {showPopup && (
        <AddEditOrganizationPopup customer={null} onClose={handleClosePopup} />
      )}
    </>
  );
}

export default OrganizationManagement;
